<template>
  <div class="paysucceed">
    <div class="paysucceed-head">
      <img
        @click="$router.push({ path: `/pays_h5/pg_record` })"
        src="@/assets/images/h5/icon22.png"
        alt=""
      />
      <p>
        {{ $t("paygame.paySuccess") }}
      </p>
    </div>
    <div class="paysucceed-content">
      <span>{{ orderList.product_name }}</span>
      <span>{{ orderList.marketing_desc1 }}</span>
      <span>{{ orderList.marketing_desc2 }}</span>
    </div>
    <div class="paysucceed-state">
      <div>
        <img src="@/assets/images/h5/icon21.png" alt="" /><span>{{
          $t("paygame.payTip1")
        }}</span>
      </div>
    </div>
    <div class="paysucceed-list">
      <div class="paysucceed-list-lable">
        <ul>
          <li>
            <span>{{ $t("paygame.paygameName") }}</span>
          </li>
          <li>
            <span>{{ $t("paygame.komoeAccount") }}</span>
          </li>
          <li>
            <span>{{ $t("paygame.gameRole") }}</span>
          </li>
          <li>
            <span>{{ $t("paygame.orderNo") }}</span>
          </li>
          <li>
            <span>{{ $t("h5page.paygame.text8") }}</span>
          </li>
          <li>
            <span>{{ $t("h5page.paygame.text9") }}</span>
          </li>
        </ul>
      </div>
      <div class="paysucceed-list-cont">
        <ul>
          <li>
            <span>{{ orderList.game_name }}</span>
          </li>
          <li>
            <span>{{ orderList.account }}</span>
          </li>
          <li>
            <span>{{ orderList.cp_role_name }}</span>
          </li>
          <li>
            <span>{{ orderList.order_no }}</span>
          </li>
          <li>
            <span>{{ orderList.payment_desc }}</span>
          </li>
          <li>
            <span class="moneys">{{ orderList.product_price }}</span
            ><span class="moneys1">({{ orderList.currency }})</span>
          </li>
        </ul>
      </div>
    </div>
    <div
      class="paysucceed-btn"
      @click="$router.push({ path: `/pays_h5/pg_record` })"
    >
      <span>{{ $t("paygame.viewHistore") }}</span>
    </div>
    <h5-nav v-if="$region !== 'jp' "></h5-nav>
  </div>
</template>
<script>
import h5Nav from "@/component/h5nav/komoe";
export default {
  name: "pays_h5Paysucceed",
  data() {
    return {
      orderList: [],
    };
  },
  created() {
    if (!this.$route.query.dataInfo) {
      this.$router.push({
        path: "/h5",
      });
      return;
    }
    this.orderList = JSON.parse(this.$route.query.dataInfo);
    // console.log(this.orderList);
    // console.log(JSON.parse(this.$route.query.dataInfo));
  },
  components: {
    h5Nav,
  },
};
</script>
<style lang="scss" scoped>
.paysucceed {
  width: 100%;
  height: auto;
  background: white;
  margin-top: 0.48rem;
  &-head {
    width: 92%;
    height: 0.5rem;
    margin: auto;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      position: absolute;
      left: 0;
      top: 50%;
      width: 0.12rem;
      height: 0.2rem;
      transform: translateY(-50%);
    }
    p {
      width: auto;
      height: 100%;
      display: flex;
      align-items: center;
      font-size: 0.22rem;
      font-weight: bold;
      color: #444444;
      position: relative;
      &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 0.8rem;
        height: 0.04rem;
        background: #50bbe5;
        border-radius: 0.02rem;
      }
    }
  }
  &-content {
    width: 92%;
    min-height: 1.57rem;
    margin: auto;
    margin-top: 0.2rem;
    background: #fbfbfb;
    border-radius: 0.11rem;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: flex-end;
    span {
      font-size: 0.1rem;
      font-weight: 400;
      color: #999999;
      margin-bottom: 0.15rem;
      &:nth-of-type(1) {
        margin-bottom: 0.17rem;
        font-size: 0.13rem;
        font-weight: bold;
        color: #444444;
      }
    }
  }
  &-state {
    width: 92%;
    height: auto;
    margin: auto;
    margin-top: 0.12rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff4cd;
    border-radius: 0.15rem;
    div {
      width: 90%;
      height: 0.3rem;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 0.14rem;
        height: 0.14rem;
        margin-right: 0.05rem;
      }
      span {
        font-size: 0.09rem;
        font-weight: 400;
        color: #ffb13b;
      }
    }
  }
  &-list {
    width: 92%;
    height: auto;
    margin: auto;
    margin-top: 0.12rem;
    display: flex;
    justify-content: space-between;
    &-lable {
      width: auto;
      height: auto;
      ul {
        width: auto;
        height: auto;
        li {
          width: auto;
          height: 0.35rem;
          display: flex;
          align-items: center;
          span {
            font-size: 0.11rem;
            font-weight: 400;
            color: #bdbdbd;
          }
        }
      }
    }
    &-cont {
      flex: 1;
      height: auto;
      display: flex;
      justify-content: flex-end;
      ul {
        width: 95%;
        height: auto;
        li {
          width: auto;
          height: 0.35rem;
          display: flex;
          align-items: center;
          span {
            font-size: 0.11rem;
            font-weight: 400;
            color: #444444;
            &.moneys {
              font-size: 0.15rem;
              font-weight: 800;
              color: #54c5f8;
            }
            &.moneys1 {
              margin-left: 0.05rem;
              font-size: 0.11rem;
              font-weight: 400;
              color: #bdbdbd;
            }
          }
        }
      }
    }
  }
  &-btn {
    width: 1.82rem;
    height: 0.35rem;
    margin: auto;
    margin-top: 0.25rem;
    margin-bottom: 0.5rem;
    background: #54c5f8;
    border-radius: 0.17rem;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      font-size: 0.12rem;
      font-weight: 400;
      color: #ffffff;
    }
  }
}
</style>
